module.exports = __webpack_public_path__ + "img/touxiang.d36e0680.png";